import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { MiaFormValues } from './MiaFormValues';
import { miaValidationRules } from './miaValidationRules';

const miaFormConfig = createFormConfig<MiaFormValues>(
  miaValidationRules as ValidationRules<keyof MiaFormValues>,
  {
    [AddressFormFieldNames.Country]: 'FR',
  }
);

export { miaFormConfig };
